var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileNative(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 18,
    viewBox: "0 0 13 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.125 0C11.3555 0 12.375 1.01953 12.375 2.25V15.75C12.375 17.0156 11.3555 18 10.125 18H2.25C0.984375 18 0 17.0156 0 15.75V2.25C0 1.01953 0.984375 0 2.25 0H10.125ZM10.6875 15.75V2.25C10.6875 1.96875 10.4062 1.6875 10.125 1.6875H2.25C1.93359 1.6875 1.6875 1.96875 1.6875 2.25V15.75C1.6875 16.0664 1.93359 16.3125 2.25 16.3125H10.125C10.4062 16.3125 10.6875 16.0664 10.6875 15.75ZM7.3125 14.0625C7.59375 14.0625 7.875 14.3438 7.875 14.625C7.875 14.9414 7.59375 15.1875 7.3125 15.1875H5.0625C4.74609 15.1875 4.5 14.9414 4.5 14.625C4.5 14.3438 4.74609 14.0625 5.0625 14.0625H7.3125Z",
    fill: "#5959EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileNative);
export default __webpack_public_path__ + "static/media/MobileNative.86309fb0c482e3eaf1e9394647ca9e74.svg";
export { ForwardRef as ReactComponent };